import { MapPin, ArrowUpRight } from "lucide-react";

function buildEmbed(address, embedUrl) {
  if (embedUrl && embedUrl.trim()) return embedUrl;
  const q = encodeURIComponent(address || "Chennai");
  // Classic free embed (no API key needed). Loads on iframe.
  return `https://maps.google.com/maps?q=${q}&t=&z=15&ie=UTF8&iwloc=B&output=embed`;
}

function buildDirections(address) {
  const q = encodeURIComponent(address || "Chennai");
  return `https://www.google.com/maps/dir/?api=1&destination=${q}`;
}

export default function MapEmbed({ settings, label = "Open in Google Maps", testid = "map-embed" }) {
  if (!settings?.address) return null;
  const embed = buildEmbed(settings.address, settings.map_embed_url);
  const directions = buildDirections(settings.address);

  return (
    <div className="brut-card overflow-hidden" data-testid={testid}>
      <a
        href={directions}
        target="_blank"
        rel="noopener noreferrer"
        className="block relative group"
        data-testid={`${testid}-link`}
      >
        <iframe
          src={embed}
          title="Diamondd Traders location"
          className="w-full h-72 border-0 pointer-events-none"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
        <div className="absolute inset-0 ring-0 group-hover:ring-2 ring-[#00A896] transition-all pointer-events-none" />
      </a>
      <a
        href={directions}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-between px-5 py-4 border-t border-[#282C33] hover:bg-[#1C1E24] transition-colors"
        data-testid={`${testid}-cta`}
      >
        <span className="flex items-start gap-3 text-sm text-[#C7CBD3]">
          <MapPin size={16} className="text-[#00A896] mt-0.5 shrink-0" />
          <span>{settings.address}</span>
        </span>
        <span className="font-mono text-xs uppercase tracking-[0.2em] text-[#00A896] flex items-center gap-1 shrink-0">
          {label} <ArrowUpRight size={14} />
        </span>
      </a>
    </div>
  );
}
